//react-components
import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import moment from "moment";

//components
import LoanApplicationListContainer from "../LoanApplicationList/LoanApplicationListContainer";
import MonthYearPicker from "../CustomUIComponents/MonthYearPicker/MonthYearPicker";
import PieChart from "../CustomUIComponents/PieChart/Piechart";
import StackedBarChart from "../CustomUIComponents/StackedBarChart/StackedBarChart";
import Calender from "../CustomUIComponents/Calendar/Calender";


//Constants
import { LOAN_CATEGORY_LEGEND } from "../Utils/Constants";

//Utils
import Utility from "../Utils/Utility";

//Styles
import "./Dashboard.scss";

//Strings
import { Strings } from "../Translations/i18n";
export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openCollapsibleSection: true,
      selectedDateForBarchart: "",
      selectedMonthForStatusCount: "",
      selectedYearForStatusCount: "",
      branchId: 0,
    };
  }

  /**
   * This function will render a legend for piechart
   */
  renderLegend = (status, color, data) => {
    let colorStyle = {
      backgroundColor: color,
    };
    return (
      <Col md={6} className="legend noPadding">
        <Row className="statusCount">
          <Col md={2} className="noPadding legendColorDiv" style={colorStyle} />
          <Col md={6} className="  legendStatusText">
            {Strings(status)}
          </Col>
        </Row>
      </Col>
    );
  };

  /**
   * This function will be called on on change of month year selection for requests.
   * THe function will call parent's function
   */
  handleChangeMonthYearSelectionForRequests = (selectedMonthYearObject) => {
    let month = moment(selectedMonthYearObject).get("month") + 1;
    let year = moment(selectedMonthYearObject).get("year");
    this.setState({
      selectedMonthForStatusCount: month,
      selectedYearForStatusCount: year,
    });
    this.props.handleChangeMonthYearSelectionForRequests(month, year);
  };

  handleMonthYearChangeForBarChartCount = (selectedMonthYearObject) => {
    let month = moment(selectedMonthYearObject).get("month") + 1;
    let year = moment(selectedMonthYearObject).get("year");
    this.props.handleMonthYearChangeForBarChartCount(month, year);
  };

  getLegendData = (legend) => {
    return this.props.requestsPieChartData.find(element => element.category === legend)
  }

  getMonthYearValue = () => {
    if (!this.state.selectedMonthForStatusCount) return ""
    return `${Strings(Utility.getLocalizationIdForMonth(Utility.getIntegerValue(this.state.selectedMonthForStatusCount)))} ${this.state.selectedYearForStatusCount}`
  }

  render() {
    return (
      <div>
        <Row className="mb-5">
          <Col md={6} className="dashboardRequestSection">
            <Row className="myRequestSection">
              <Row className="justify-content-end">
                <Col md={6} className="mainHeaderApplication myRequestsHeading">
                  {Strings("requests")}
                </Col>
                <Col md={6}>
                  <Calender
                    className="monthYearSelection"
                    dateFormat={"MM-YYYY"}
                    placeholder={"Seleccione mes"}
                    handleChange={this.handleChangeMonthYearSelectionForRequests}
                    value={this.getMonthYearValue()}
                    viewMode={"months"}
                    isAfter={true} />
                </Col>
              </Row>
              <Row>
                <Col md={4} className="noPadding">
                  {this.props.requestsPieChartData.length !== 0 ? (
                    <PieChart
                      data={this.props.requestsPieChartData}
                      colors={this.props.requestsPieColors}
                      strokeWidth={2}
                      strokeColor="#fff"
                      total={this.props.totalRequests}
                    />
                  ) : (
                    <div className=" errorNoData">{Strings("noData")}</div>
                  )}
                </Col>
                <Col md={8} className="noPadding">
                  <div className="requestCount">{this.props.totalRequests}</div>

                  <Row>
                    {LOAN_CATEGORY_LEGEND.map((legend) => {
                      return this.renderLegend(legend.key, legend.color, this.getLegendData(legend.key));

                    })}
                  </Row>
                </Col>
              </Row>
            </Row>
          </Col>

          <Col md={6} className="dashboardCommissionSection">
            <Row className="dashboardSecondSection">
              <Row className="dashBoardBarchartHeader">
                <Col
                  md={8}
                  className="mainHeaderApplication noPaddingDashBoard"
                >
                  {Strings("Reports")}
                </Col>

                <Col md={7} className="d-flex justify-content-end">
                  <MonthYearPicker
                    handleChangeMonthYearSelection={
                      this.handleMonthYearChangeForBarChartCount
                    }
                    countOfMonths={2}
                  />
                </Col>
              </Row>
              <Row className="applicationsBarchart">
                <StackedBarChart
                  dataKeys={this.props.barChartDataCountKeys}
                  data={this.props.barChartDataCount}
                  barchartColors={this.props.barChartDataCountColors}
                />
              </Row>
            </Row>
          </Col>
        </Row>

        <LoanApplicationListContainer
          LOAN_PORTFOLIO={this.props.LOAN_PORTFOLIO}
        />
      </div>
    );
  }
}
